import PropTypes from 'prop-types';
import Inflector from '../utils/inflector';

const inflector = new Inflector();

export default function NoTranslatePluralize(props) {
  const { text, length } = props;

  return (
     
    <span dangerouslySetInnerHTML={{ __html: inflector.notranslate_pluralize(text, length) }} />
  );
}

NoTranslatePluralize.propTypes = {
  text: PropTypes.string.isRequired,
  length: PropTypes.number.isRequired,
};
